'use client';
import React, { createContext, useContext, useState } from 'react';
import { useUser } from './UserProvider';
import { ProfileSlider } from '@/components/user-profile/profile-slider';

interface ProfileSliderContextType {
  openSlider: (current_path?: string) => void;
  closeSlider: () => void;
  isOpen: boolean;
}

const ProfileSliderContext = createContext<
  ProfileSliderContextType | undefined
>(undefined);

interface ProfileSliderProviderProps {
  children: React.ReactNode;
  node_locale?: string;
  brandId?: string;
  config?: any;
}

export const ProfileSliderProvider = ({
  children,
  node_locale,
  brandId,
  config,
}: ProfileSliderProviderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentPath, setCurrentPath] = useState<string | undefined>();
  const { user, isLoggedIn } = useUser();

  return (
    <ProfileSliderContext.Provider
      value={{
        isOpen,
        openSlider: (current_path?: string) => {
          // updated
          setCurrentPath(current_path);
          setIsOpen(true);
        },
        closeSlider: () => setIsOpen(false),
      }}
    >
      {children}
      {node_locale && brandId && config && (
        <ProfileSlider
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          isLoggedIn={isLoggedIn}
          user={user}
          node_locale={node_locale}
          brandId={brandId}
          config={config}
          current_path={currentPath}
        />
      )}
    </ProfileSliderContext.Provider>
  );
};

export const useProfileSlider = (): ProfileSliderContextType => {
  const context = useContext(ProfileSliderContext);
  if (!context) {
    return {
      isOpen: false,
      openSlider: () => {},
      closeSlider: () => {},
    };
  }
  return context;
};
